const Line = () => (
  <svg width="2" height="12" viewBox="0 0 2 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 0L1 12" stroke="white" strokeOpacity="0.3" />
  </svg>
)
export default Line
